(() => {
  if (window.__cmConversionGuardReady) return;
  window.__cmConversionGuardReady = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  function isCart() {
    const root = $('[data-cx-root]');
    return location.pathname.replace(/\/$/, '') === '/cart' || !!(root && root.classList.contains('cx-template-cart'));
  }

  function isCartDrawerOpen() {
    return !!$('cart-drawer.active, cart-drawer.animate.active, cart-drawer[open], #CartDrawer.active, .cart-drawer.active');
  }

  function isCartSurface() {
    return isCart() || isCartDrawerOpen();
  }

  function isAcademiaSurface() {
    const path = location.pathname.replace(/\/$/, '');
    return path === '/pages/cosemania-formacion' ||
      path === '/pages/academia-cosemania' ||
      path.includes('/apps/my/courses') ||
      path.includes('/products/curso-profesional-de-mecanica-y-mantenimiento-de-maquinas-de-coser-domesticas') ||
      path.includes('/products/curso-mantenimiento-reparacion-maquinas-industriales') ||
      path.includes('/products/academia-cosemania');
  }

  function isProduct() {
    const root = $('[data-cx-root]');
    return location.pathname.includes('/products/') || !!(root && root.classList.contains('cx-template-product'));
  }

  function visible(element) {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 1 && rect.height > 1 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.05;
  }

  function directChild(container, element) {
    let node = element;
    while (node && node.parentElement && node.parentElement !== container) node = node.parentElement;
    return node && node.parentElement === container ? node : element;
  }

  function markTemplates() {
    const cart = isCart();
    const drawer = isCartDrawerOpen();
    document.documentElement.classList.toggle('cm-cart', cart);
    document.documentElement.classList.toggle('cm-cart-drawer-open', drawer);
    document.documentElement.classList.toggle('cm-cart-surface', cart || drawer);
    document.documentElement.classList.toggle('cm-product', isProduct());
    document.documentElement.classList.toggle('cm-academia-surface', isAcademiaSurface());
  }

  function moveShippingLine() {
    const line = $('[data-cm-shipping-line]');
    if (!line) return;
    if (isAcademiaSurface()) {
      line.hidden = true;
      return;
    }
    const header = $('.shopify-section-header, header, .header-wrapper');
    const main = $('main');
    if (header && header.nextElementSibling !== line) header.insertAdjacentElement('afterend', line);
    if (!header && main && main.firstElementChild !== line) main.insertAdjacentElement('afterbegin', line);
    line.hidden = false;
  }

  function moveCartShipping() {
    const panel = $('[data-cm-cart-shipping]');
    const main = $('main');
    if (!panel || !main) return;
    if (isAcademiaSurface()) {
      panel.hidden = true;
      return;
    }
    const anchor = $('.title-wrapper-with-link, .cart__warnings, h1', main) || $('cart-items, .cart-items, .cart__items, form[action="/cart"]', main) || main.firstElementChild || main;
    if (anchor === main) main.insertAdjacentElement('afterbegin', panel);
    else anchor.insertAdjacentElement('afterend', panel);
    panel.hidden = false;
  }

  function productShippingNote() {
    if (isAcademiaSurface()) {
      $$('[data-cm-product-shipping-note]').forEach((element) => element.remove());
      return;
    }
    if (!isProduct() || $('[data-cm-product-shipping-note]')) return;
    const info = $('.product__info-container');
    const form = info && $('product-form, form[action*="/cart/add"], .product-form', info);
    if (!info || !form) return;
    const note = document.createElement('div');
    note.className = 'cm-product-shipping-note';
    note.dataset.cmProductShippingNote = 'true';
    note.innerHTML = '<strong>Gastos de env&iacute;o antes de pagar</strong><span>Pen&iacute;nsula: 5,90 &euro; hasta 49,99 &euro; y gratis desde 50 &euro;. Baleares/Ceuta/Melilla: 6,90 &euro; y gratis desde 75 &euro;. Canarias: desde 11,95 &euro; seg&uacute;n peso.</span>';
    directChild(info, form).insertAdjacentElement('afterend', note);
  }

  function clearSuppressedObstacles() {
    $$('[data-cm-cart-suppressed="true"]').forEach((element) => {
      element.removeAttribute('data-cm-cart-suppressed');
      element.removeAttribute('aria-hidden');
    });
    $$('shopify-forms-embed, shopify-chat').forEach((element) => {
      if (!element.shadowRoot) return;
      const style = element.shadowRoot.getElementById('cm-cart-shadow-suppress');
      if (style) style.remove();
    });
  }

  function suppressShadowObstacles(element) {
    if (!element.shadowRoot) return;

    let style = element.shadowRoot.getElementById('cm-cart-shadow-suppress');
    if (!style) {
      style = document.createElement('style');
      style.id = 'cm-cart-shadow-suppress';
      element.shadowRoot.appendChild(style);
    }

    style.textContent = [
      '#app-embed',
      '.appEmbed',
      '[data-testid="app-router"]',
      '[data-testid="form-teaser"]',
      '.activator-nudge',
      'button.activator'
    ].join(',') + '{display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important;transform:scale(0)!important}';
  }

  function suppressMobileCartObstacles() {
    if (!isCartSurface() || window.innerWidth > 760) {
      clearSuppressedObstacles();
      return;
    }

    const selectors = [
      'shopify-chat',
      'shopify-forms-embed',
      '#ShopifyChat',
      '#shopify-chat',
      '[id*="shopify-chat" i]',
      '[id*="ShopifyChat" i]',
      '#app-embed-container-260559',
      '[id^="app-embed-container"]',
      '#PBarNextFrameWrapper',
      '[id^="PBar"]',
      '[id*="PBar"]',
      'body > .gta-widget.gta-bar',
      'body > [class*="gta-bar" i]',
      'body > [class*="GSC-BAR" i]',
      '[class*="pbar" i]',
      '[class*="privy" i]',
      '[class*="klaviyo-form" i]'
    ].join(',');

    $$(selectors).forEach((element) => {
      if (element.closest('.cm-cart-paybar, .shopify-pc__banner, .shopify-pc__prefs')) return;
      element.dataset.cmCartSuppressed = 'true';
      element.setAttribute('aria-hidden', 'true');
      suppressShadowObstacles(element);
    });

    const words = /(descuento|discount|5%|primer pedido|coupon|cupon|popup|privy|klaviyo|pbar|necesitas ayuda|ayuda|chat|inbox|gsc|gta)/i;
    $$('body > div, body > aside, body > section, body > iframe, body > shopify-chat, body > shopify-forms-embed').forEach((element) => {
      if (element.closest('.cm-cart-paybar, .shopify-pc__banner, .shopify-pc__prefs')) return;
      const rect = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      const shadowText = element.shadowRoot ? element.shadowRoot.textContent || '' : '';
      const text = `${element.id || ''} ${element.className || ''} ${element.textContent || ''} ${shadowText}`;
      if ((style.position === 'fixed' || element.tagName === 'SHOPIFY-FORMS-EMBED') && rect.bottom > window.innerHeight - 260 && words.test(text)) {
        element.dataset.cmCartSuppressed = 'true';
        element.setAttribute('aria-hidden', 'true');
        suppressShadowObstacles(element);
      }
    });

    $$('shopify-forms-embed, shopify-chat').forEach(suppressShadowObstacles);
  }

  function parseColor(value) {
    const match = String(value || '').match(/rgba?\(([^)]+)\)/i);
    if (!match) return null;
    const parts = match[1].split(',').map((part) => Number.parseFloat(part.trim()));
    return parts.length >= 3 ? { r: parts[0], g: parts[1], b: parts[2], a: parts[3] ?? 1 } : null;
  }

  function lightness(color) {
    return (color.r * 0.2126 + color.g * 0.7152 + color.b * 0.0722) / 255;
  }

  function backgroundFor(element) {
    let node = element;
    while (node && node !== document.documentElement) {
      const color = parseColor(getComputedStyle(node).backgroundColor);
      if (color && color.a > 0.75) return color;
      node = node.parentElement;
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  function improveContrast() {
    const selector = 'main h1,main h2,main h3,main p,main li,main span,main a,main summary,header a,header button,footer a,footer p,footer li,.card__heading,.card-information,.price,.badge,.banner__heading,.banner__text';
    $$(selector).slice(0, 360).forEach((element) => {
      if (!visible(element) || !(element.textContent || '').trim()) return;
      if (element.closest('.cm-cart-paybar, .cm-shipping-line, .cm-cart-shipping, .cm-product-shipping-note')) return;
      const fg = parseColor(getComputedStyle(element).color);
      const bg = backgroundFor(element);
      if (!fg || Math.abs(lightness(fg) - lightness(bg)) > 0.42) return;
      element.classList.toggle('cm-readable-light', lightness(bg) > 0.45);
      element.classList.toggle('cm-readable-dark', lightness(bg) <= 0.45);
    });
  }

  function run() {
    markTemplates();
    moveShippingLine();
    moveCartShipping();
    productShippingNote();
    suppressMobileCartObstacles();
    improveContrast();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  window.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', run);
  [400, 1200, 2400, 4200, 6200].forEach((delay) => setTimeout(run, delay));
  new MutationObserver(() => requestAnimationFrame(run)).observe(document.body, { childList: true, subtree: true });
})();
